import { useEffect, useState, useRef } from "react";
import ReactTabulator from "react-tabulator/lib/ReactTabulator";
import axios from "axios";
import { toast } from "react-toastify";
const ReportConditions = (props) => {
  const [fieldType, setFieldType] = useState([]);
  const [conditionData, setConditionData] = useState([]);
  const [conditionRadio, setConditionRadio] = useState(false);

  const tableRef = useRef(null);
  const conditionTypeRef = useRef(null);
  const valueRef = useRef(null);
  const fieldRef = useRef(null);

  useEffect(() => {
    axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl2")}w/grc/`,
      params: { key: props.field },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setFieldType(response.data);
    });
  }, [props.field]);
  useEffect(() => {
    conditionData.length >= 1 && setConditionRadio(true);
    props.table?.length !== 0
      ? setConditionData(props.table)
      : setConditionData([]);
    !props.data && setConditionData("");
  }, [conditionData.length, props.data, props.table]);
  // const tableOptions = {
  //   layout: "fitDataStretch",
  //   selectable: 1,
  // };
  const tableColumns = [
    {
      title: "منطق",
      field: "logic",
    },
    {
      title: "نام فیلد",
      field: "field",
    },
    {
      title: "عملگر",
      field: "operator",
    },
    {
      title: "مقدار شرط",
      field: "value",
    },
    {
      title: " حذف",
      formatter: "buttonCross",
      cellClick: function (e, cell) {
        cell.getRow().delete();
      },
    },
  ];
  const changeRadioHandler = (e) => {
    let value = e.target.value;
    setConditionRadio(value);
  };

  function addRowHandler(e) {
    e.preventDefault();
    let data = {
      field: fieldRef.current?.value,
      operator: conditionTypeRef.current?.value,
      value: valueRef.current?.value,
      logic: conditionRadio !== false ? conditionRadio : "",
    };
    if (
      (data.field.trim() || data.operator.trim()) === "default" ||
      data.value.trim() === "" ||
      (conditionRadio && data.logic === true)
    ) {
      toast.error("لطفا تمامی فیلدهای مربوط به شرط را پر کنید");
    } else {
      setConditionData([...conditionData, data]);
      props.onSaveReportCondition(data);
      fieldRef.current.value = "default";
      conditionTypeRef.current.value = "default";
      valueRef.current.value = "";
      setConditionRadio(true);
    }
  }

  return (
    <>
      <div className="title-template">
        <div className="line-dashed"></div>
        <div className="lable-box-title-new">
          <label className="headLabel">شرط</label>
        </div>
      </div>
      <div>
        {conditionRadio && (
          <div className="selectBox-sides">
            <label htmlFor="" className="form-label labelMargin"></label>
            <div className="radioBox-flex" onChange={changeRadioHandler}>
              <div className=" margin-radious">
                <input
                  className="form-check-input"
                  type="radio"
                  name="logic"
                  id="inlineRadio5"
                  value="AND"
                />
                <label className="" htmlFor="inlineRadio5">
                  &&
                </label>
              </div>
              <div className=" margin-radious">
                <input
                  className="form-check-input"
                  type="radio"
                  name="logic"
                  id="inlineRadio6"
                  value="OR"
                />
                <label className="" htmlFor="inlineRadio6">
                  ||
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="selectWidthComplete">
          <label
            htmlFor="id1"
            className=" control-label form-label labelMargin"
          >
            نام فیلد
          </label>
          <select
            className="inputBox"
            ref={fieldRef}
            defaultValue={"default"}
            id="id1"
            name="field"
          >
            <option value="default">انتخاب کنید</option>
            {fieldType?.map((v) => (
              <option value={v.key}>{v.name}</option>
            ))}
          </select>
        </div>
        <div className="selectBox">
          <div className="selectBox-sides">
            <label
              htmlFor="id2"
              className="control-lable form-label labelMargin"
            >
              نوع شرط
            </label>
            <select
              className="inputBox"
              ref={conditionTypeRef}
              defaultValue={"default"}
              id="id2"
              name="operator"
            >
              <option value={"default"}>
                گزینه مورد نظر خود را انتخاب کنید
              </option>
              <option value=">">بزرگ تر</option>
              <option value="<">کوچک تر</option>
              <option value="=">مساوی</option>
            </select>
          </div>
          <div className="selectBox-sides selectBox">
            <label
              htmlFor="id3"
              className="control-lable form-label labelMargin"
            >
              مقدار شرط
            </label>
            <input
              type="text"
              className="form-control inputBox"
              ref={valueRef}
              placeholder="مقدار شرط"
              name="value"
            />
          </div>
        </div>
      </div>

      <div className="button-box mb-4">
        <button type="submit" className="mx-auto mt-5" onClick={addRowHandler}>
          تایید
        </button>
      </div>
      <div className="tableBox resSizeTable">
        <ReactTabulator
          ref={tableRef}
          columns={tableColumns}
          data={conditionData !== undefined ? conditionData : []}
          // dataChanged={(newData) => console.log("dataChanged", newData)}
          // options={tableOptions}
          style={{ height: "50vh" }}
        />
      </div>
    </>
  );
};
export default ReportConditions;
